(function () {
  var root = document.querySelector('[data-cc-hero]#cc-buy');
  if (!root || root.dataset.ccReady) return;
  root.dataset.ccReady = '1';

  var track = root.querySelector('[data-cc-track]');
  var thumbs = root.querySelectorAll('[data-cc-thumb]');
  function goTo(i) { if (track) track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' }); }
  thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(+t.dataset.ccThumb); }); });
  if (track && thumbs.length) {
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      thumbs.forEach(function (t, n) {
        t.setAttribute('aria-current', n === i ? 'true' : 'false');
        if (n === i && t.parentNode) t.parentNode.scrollTo({ left: t.offsetLeft - 20, behavior: 'smooth' });
      });
    }, { passive: true });
  }

  var qtyInput = root.querySelector('[data-cc-qty-input]');
  root.querySelectorAll('[data-cc-qty]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!qtyInput) return;
      qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + (+b.dataset.ccQty));
    });
  });

  var jsonEl = root.querySelector('[data-cc-json]');
  if (!jsonEl) return;
  var data = JSON.parse(jsonEl.textContent);
  var fmt = function (cents) {
    try { return new Intl.NumberFormat('en-AU', { style: 'currency', currency: data.currency || 'AUD' }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  };
  var qtyOf = function (val) { var n = parseInt(val, 10); return isNaN(n) || n < 1 ? 1 : n; };
  var $ = function (s) { return root.querySelector(s); };

  function selected() {
    var opts = [];
    root.querySelectorAll('[data-cc-option]').forEach(function (el) {
      var i = +el.dataset.ccOption;
      if (el.type === 'radio') { if (el.checked) opts[i] = el.value; } else opts[i] = el.value;
    });
    return opts;
  }
  function find(opts) {
    return data.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
  }

  function render() {
    var opts = selected();
    var v = find(opts);

    if (data.packIndex > -1) {
      var cards = root.querySelectorAll('[data-cc-pack]');
      var base = null;
      cards.forEach(function (card) {
        var o = opts.slice(); o[data.packIndex] = card.dataset.ccPack;
        var pv = find(o);
        if (pv && qtyOf(card.dataset.ccPack) === 1) base = pv;
      });
      cards.forEach(function (card) {
        var o = opts.slice(); o[data.packIndex] = card.dataset.ccPack;
        var pv = find(o);
        var q = qtyOf(card.dataset.ccPack);
        var each = card.querySelector('[data-cc-each]');
        var was = card.querySelector('[data-cc-was]');
        var save = card.querySelector('[data-cc-pack-save]');
        if (!pv) { card.setAttribute('data-unavailable', ''); each.textContent = 'Unavailable'; was.textContent = ''; save.textContent = ''; return; }
        if (pv.available) card.removeAttribute('data-unavailable'); else card.setAttribute('data-unavailable', '');
        each.innerHTML = fmt(Math.round(pv.price / q)) + '<small>/each</small>';
        var s = base ? base.price * q - pv.price : 0;
        was.textContent = s > 0 ? fmt(base.price) + '/each' : '';
        save.textContent = s > 0 ? 'Save ' + fmt(s) : '';
      });
    }

    root.querySelectorAll('[data-cc-opt-name]').forEach(function (el) { el.textContent = opts[+el.dataset.ccOptName] || ''; });

    var atc = $('[data-cc-atc]'), label = $('[data-cc-atc-label]'), stickyBtn = $('[data-cc-sticky-btn]');
    if (!v) {
      atc.disabled = true; label.textContent = 'Unavailable';
      if (stickyBtn) stickyBtn.disabled = true;
      return;
    }
    $('[data-cc-variant-id]').value = v.id;
    $('[data-cc-price]').textContent = fmt(v.price);
    var compareEl = $('[data-cc-compare]');
    if (v.compare > v.price) { compareEl.hidden = false; compareEl.textContent = fmt(v.compare); } else { compareEl.hidden = true; }
    atc.disabled = !v.available;
    label.textContent = v.available ? data.buttonLabel : 'Sold out';
    if (stickyBtn) stickyBtn.disabled = !v.available;
    var sp = $('[data-cc-sticky-price]'); if (sp) sp.textContent = fmt(v.price);
    var sv = $('[data-cc-sticky-variant]'); if (sv) sv.textContent = v.title;
    var stock = $('[data-cc-stock]'); if (stock) stock.hidden = !v.available;

    if (v.media && track) {
      track.querySelectorAll('[data-media-id]').forEach(function (s, i) { if (+s.dataset.mediaId === v.media) goTo(i); });
    }
  }

  var eta = $('[data-cc-eta]');
  if (eta) {
    var addBiz = function (d, n) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; } return x; };
    var f = function (d) { return d.toLocaleDateString(data.locale || 'en-AU', { weekday: 'short', day: 'numeric', month: 'short' }); };
    var now = new Date();
    eta.querySelector('[data-cc-eta-text]').textContent = (eta.dataset.prefix || 'Order today, arrives') + ' ' + f(addBiz(now, +eta.dataset.min || 5)) + ' to ' + f(addBiz(now, +eta.dataset.max || 10));
    eta.hidden = false;
  }

  root.addEventListener('change', function (e) { if (e.target.matches('[data-cc-option]')) render(); });
  render();

  // Add-ons: add ticked accessories in the same cart request
  var form = root.querySelector('form.cc-buy');
  if (form && root.querySelector('[data-cc-upsell]')) {
    form.addEventListener('submit', function (e) {
      var extras = Array.prototype.slice.call(root.querySelectorAll('[data-cc-upsell-item]:checked'));
      if (!extras.length) return;
      e.preventDefault();
      var items = [{ id: +root.querySelector('[data-cc-variant-id]').value, quantity: Math.max(1, parseInt((qtyInput || {}).value, 10) || 1) }];
      extras.forEach(function (x) { items.push({ id: +x.value, quantity: 1 }); });
      var dest = form.querySelector('input[name="return_to"]') ? '/checkout' : '/cart';
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function () { if (dest === '/cart' && window.CCCart) { window.CCCart.refresh(true); } else { window.location.href = dest; } })
        .catch(function () { form.submit(); });
    });
  }

  /* qty vs pack hint: suggest the pack when someone picks 2+ of the single fan */
  var hint = $('[data-cc-qty-hint]');
  if (hint && qtyInput && data.packIndex > -1) {
    var hintText = hint.querySelector('[data-cc-qty-hint-text]');
    var hintBtn = hint.querySelector('[data-cc-qty-hint-btn]');
    var target = null;
    var checkHint = function () {
      target = null;
      var qty = qtyOf(qtyInput.value);
      var opts = selected();
      var cur = find(opts);
      var packs = Array.prototype.slice.call(root.querySelectorAll('input[data-cc-option="' + data.packIndex + '"][type="radio"]'));
      var curCount = parseInt(opts[data.packIndex], 10) || 1;
      if (cur && qty >= 2 && curCount === 1) {
        packs.forEach(function (r) {
          if ((parseInt(r.value, 10) || 0) === qty) {
            var o = opts.slice(); o[data.packIndex] = r.value;
            var pv = find(o);
            if (pv && pv.available) {
              var saving = cur.price * qty - pv.price;
              if (saving > 0) target = { radio: r, name: r.value, price: pv.price, saving: saving };
            }
          }
        });
      }
      if (target) {
        hintText.textContent = 'Get the ' + target.name + ' pack for ' + fmt(target.price) + ' and save ' + fmt(target.saving) + '.';
        hint.hidden = false;
      } else {
        hint.hidden = true;
      }
    };
    hintBtn.addEventListener('click', function () {
      if (!target) return;
      target.radio.checked = true;
      target.radio.dispatchEvent(new Event('change', { bubbles: true }));
      qtyInput.value = 1;
      checkHint();
    });
    qtyInput.addEventListener('input', checkHint);
    qtyInput.addEventListener('change', checkHint);
    root.querySelectorAll('[data-cc-qty]').forEach(function (b) { b.addEventListener('click', checkHint); });
    root.addEventListener('change', function (e) { if (e.target.matches('[data-cc-option]')) checkHint(); });
    checkHint();
  }

  var stickyBar = $('[data-cc-sticky]');
  var mainBtn = $('[data-cc-atc]');
  if (stickyBar && mainBtn) {
    var ticking = false;
    var update = function () {
      ticking = false;
      var show = mainBtn.getBoundingClientRect().bottom < 0;
      if (show === stickyBar.classList.contains('is-visible')) return;
      stickyBar.classList.toggle('is-visible', show);
      stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
      var btn = stickyBar.querySelector('button'); if (btn) btn.tabIndex = show ? 0 : -1;
    };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }
})();

/* free gift row: on when the selected variant x quantity reaches the spend */
(function () {
  var root = document.querySelector('[data-cc-hero]#cc-buy');
  if (!root) return;
  var row = root.querySelector('[data-cc-giftrow]');
  var jsonEl = root.querySelector('[data-cc-json]');
  if (!row || !jsonEl) return;
  var data = JSON.parse(jsonEl.textContent);
  var threshold = +row.dataset.threshold || 0;
  var qtyInput = root.querySelector('[data-cc-qty-input]');
  function selected() {
    var opts = [];
    root.querySelectorAll('[data-cc-option]').forEach(function (el) {
      var i = +el.dataset.ccOption;
      if (el.type === 'radio') { if (el.checked) opts[i] = el.value; } else opts[i] = el.value;
    });
    return opts;
  }
  function update() {
    var opts = selected();
    var v = data.variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
    var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
    row.classList.toggle('is-on', !!v && v.price * qty >= threshold);
  }
  var btn = row.querySelector('[data-cc-giftrow-btn]');
  if (btn && data.packIndex > -1) {
    btn.addEventListener('click', function () {
      var from = Math.max(1, +row.dataset.from || 2);
      var radios = root.querySelectorAll('input[data-cc-option="' + data.packIndex + '"][type="radio"]');
      var r = radios[from - 1];
      if (!r) return;
      r.checked = true;
      if (qtyInput) qtyInput.value = 1;
      r.dispatchEvent(new Event('change', { bubbles: true }));
      update();
    });
  }
  root.addEventListener('change', update);
  root.addEventListener('click', function (e) { if (e.target.closest('[data-cc-qty]')) setTimeout(update, 0); });
  if (qtyInput) qtyInput.addEventListener('input', update);
  update();
})();
